<div class="not-found-container">
  <div class="not-found-card">
    <div class="not-found-icon">
      <i class="fas fa-search"></i>
    </div>
    <h1 class="not-found-title">Recurso no encontrado</h1>
    <p class="not-found-message">
      Lo sentimos, el contenido que estás buscando no existe o ha sido eliminado de nuestro catálogo.
    </p>

    <div class="not-found-suggestions">
      <h3>Te sugerimos:</h3>
      <ul>
        <li>Verifica que el enlace sea correcto</li>
        <li>Explora nuestro catálogo completo</li>
        <li>Utiliza nuestro buscador para encontrar contenido relacionado</li>
      </ul>
    </div>

    <div class="not-found-actions">
      <button class="btn-action btn-primary" (click)="navigateTo('/fotografias')">
        <i class="fas fa-camera"></i>
        Ver Fotografías
      </button>
      <button class="btn-action btn-primary" (click)="navigateTo('/portadas')">
        <i class="fas fa-newspaper"></i>
        Ver Páginas Históricas
      </button>
      <button class="btn-action btn-secondary" (click)="navigateTo('/')">
        <i class="fas fa-home"></i>
        Volver al Inicio
      </button>
    </div>
  </div>
</div>
